import * as React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import useVendingCartDesigner, {
  CANVAS_WIDTH,
} from "../hooks/useVendingCartDesigner"
import { useDropzone } from "react-dropzone"
import { useHistory } from "react-router-dom"
import { RingLoader } from "../../shared/components/Spinner"
import ConditionalRender from "../../shared/components/ConditionalRender"
import CartList from "./CartList"
import { cartType } from "./types"
import Extensions from "./Extensions"
import useCartExtension from "./../hooks/useCartExtension"

const Wrapper = styled.div`
  max-width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  position: relative;

  .canvas-container {
    max-width: ${CANVAS_WIDTH}px;
    width: 100% !important;
    margin: 0 auto !important;
    @media (max-width: 767px) {
      transform: scale(0.75, 0.3);
      height: 400px !important;
    }
  }
`

const Footer = styled.div`
  margin: 20px 0;
`

const NextButton = styled.button`
  outline: none;
  background-color: transparent;
  line-height: 34px;
  padding: 6px 12px;
  border: 1px solid black;
  border-radius: 6px;
  min-width: 140px;
  cursor: pointer;

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`

const ACCEPT = "image/jpeg, image/png"

const CartCustomizer = ({ cart, path, carts }) => {
  const [logo, setPath] = React.useState(null)
  const [currentCart, setCurrentCart] = React.useState(cart)
  const { activeExtensions, onExtensionClick } = useCartExtension()
  const history = useHistory()
  const { getInputProps, open } = useDropzone({
    onDrop: (acceptedFiles) => {
      const file = acceptedFiles[0]
      const reader = new FileReader()
      reader.onabort = () => console.log("file reading was aborted")
      reader.onerror = () => console.log("file reading has failed")
      reader.onload = () => {
        const preview = reader.result
        setPath(preview)
      }

      reader.readAsDataURL(file)
    },
    accept: ACCEPT,
    noClick: true,
    noKeyboard: true,
  })

  const { canvasRef, ctx, isLoaded } = useVendingCartDesigner({
    imgPath: currentCart.image_url,
    logo,
    onUploadSectionClick: open,
    activeExtensions,
    onRemoveLogo: () => setPath(null),
  })

  const onNext = () => {
    history.push({
      pathname: path,
      state: {
        resultImg: ctx?.toDataURL(),
        cart: currentCart,
      },
    })
  }

  return (
    <Wrapper>
      <canvas ref={canvasRef} />
      <CartList items={carts} onClick={setCurrentCart} />
      <ConditionalRender
        shouldRender={isLoaded}
        fallback={<RingLoader color="black" overlay={false} />}
      >
        <input {...getInputProps()} />
        <Footer>
          <NextButton onClick={onNext} disabled={logo === null}>
            Next
          </NextButton>
        </Footer>
      </ConditionalRender>
      <Extensions selected={activeExtensions} onClick={onExtensionClick} />
    </Wrapper>
  )
}

CartCustomizer.propTypes = {
  cart: cartType,
  path: PropTypes.string.isRequired,
  carts: PropTypes.arrayOf(cartType),
}

export default CartCustomizer
